import {
  buildPath,
  buildTemplatePath,
  ListContext,
  ListContextValue,
  Page,
  PageRoute,
  pn,
  Stack,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import {
  Permission,
  Staff,
  StaffEditResource,
  StaffEmployment as StaffEmploymentModel,
  StaffViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { StaffEmployment } from "./StaffEmployment";
import { StaffPageHeader } from "./StaffPageHeader";
import { StaffBasicInfo } from "../StaffPage/StaffProfile/StaffBasicInfo";

const routeName = "createStaff";

export const staffCreatePageRoute: PageRoute = {
  handle: "New Staff",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const StaffCreatePage = () => {
  const ROOT_PERMISSION: Permission = Permission.Staff;
  const [staff, setStaff] = useState<Staff>({} as Staff);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [staff] });
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const [viewResource, setViewResource] = useState<StaffViewResource>({});
  const [editResource, setEditResource] = useState<StaffEditResource>({});
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(0);
    fetchViewResource(0);
    fetchEditResource();
  }, []);

  const fetch = (id: number) => {
    ApiService.staff.get(id).then((response) => {
      setStaff(response);
      resetUnsavedChanges([response]);
    });
  };

  const fetchViewResource = (id: number) => {
    ApiService.staff.getViewResource(id).then((response) => {
      setViewResource(response);
    });
  };

  const fetchEditResource = () => {
    ApiService.staff.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  return (
    <Page
      isForm
      header={
        <StaffPageHeader
          handle={staffCreatePageRoute.handle}
          staff={staff}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
        />
      }
    >
      <Stack spacing="lg">
        <StaffBasicInfo
          staff={staff}
          setStaff={setStaff}
          viewResource={viewResource}
          editResource={editResource}
          crudMode={"edit"}
          validationErrors={validationErrors}
        />

        <StaffEmployment
          employment={staff?.creatingFirstEmployment || ({} as StaffEmploymentModel)}
          setEmployment={(employment) =>
            setStaff(
              produce((draft) => {
                draft.creatingFirstEmployment = employment;
              })
            )
          }
          validationErrors={validationErrors[pn<Staff>("creatingFirstEmployment")] || {}}
        />
      </Stack>
    </Page>
  );
};
